import React, { useEffect, useRef, useState } from "react";
import { AutoComplete, Button, Icon, Input } from 'antd';
import { Link } from "react-router-dom";
import { createDebounce } from '../../util/methods';

const { Option } = AutoComplete;

function renderOption(item, locations, subLocations, locationNameById, clientNameById) {

  const { _id, searchRecordName: dirty_name, searchModuleType: moduleType, searchRecordId: alteredId, searchRecord: record } = item;
  // console.log(record.location);
  let isShow = true;
  let recordName = '';
  let url = '';
  let icon = 'bell';
  let name = typeof dirty_name === 'string'
    ? dirty_name.replace(/\b(null|undefined|NaN)\b/gi, '').replace(/\s+/g, ' ').trim()
    : dirty_name;

  switch (moduleType) {
    case 'asset':
      recordName = `Asset code ${name}`;
      url = `/asset/history-report/${alteredId}`;
      icon = 'car';
      isShow = (locations && record.location && locations.length) ? locations.includes(record.location)
        : (subLocations && record.client && subLocations.length) ? subLocations.includes(record.client) : true;
      break;
    case 'jobcard':
      recordName = `Job code ${name}`;
      url = `/job-card/report/${alteredId}`;
      icon = 'carry-out';
      break;
    case 'complaint':
      recordName = `Complaint No ${name}`;
      url = `/complaint/edit/${alteredId}`;
      icon = 'fire';
      isShow = (locations && record.location && locations.length) ? locations.includes(record.location)
        : (subLocations && record.client && subLocations.length) ? subLocations.includes(record.client) : true;
      break;
    case 'purchaseorder':
      recordName = `PO No ${name}`;
      url = `/purchase-order/view/${alteredId}`;
      icon = 'tag';
      break;
    case 'sparepart':
      recordName = `Spare Name ${name}`;
      url = `/spare-part/edit/${alteredId}`;
      icon = 'tool';
      break;
    case 'saleorder':
      recordName = `Sale Invoice ${name}`;
      url = `/sale-order/view/${alteredId}`;
      icon = 'import';
      break;
    case 'invoiceentry':
      recordName = `TINV No ${name}`;
      url = `/invoice-entry/edit/${alteredId}`;
      icon = 'switcher';
      break;
    case 'assettransferadvice':
      recordName = `ATA No ${name}`;
      url = `/asset-transfer-advice/view/${alteredId}`;
      icon = 'rise';
      break;
    case 'assetreceiptnote':
      recordName = `ARN No ${name}`;
      url = `/asset-receipt-note/view/${alteredId}`;
      icon = 'fall';
      break;
    case 'sparetransferadvice':
      recordName = `STA No ${name}`;
      url = `/spare-transfer-advice/edit/${alteredId}`;
      icon = 'rise';
      break;
    case 'sparereceiptadvise':
      recordName = `SRA No ${name}`;
      url = `/spare-receipt-advise/edit/${alteredId}`;
      icon = 'fall';
      break;
    case 'contract':
      recordName = `Contract id ${name}`;
      url = `/contract/view/${alteredId}`;
      icon = 'solution';
      break;
    case 'vendor':
      recordName = `Vendor name ${name}`;
      url = `/vendor/edit/${alteredId}`;
      icon = 'gift';
      break;
    case 'equipmentsubtype':
      recordName = `with Sub Type ${name}`;
      url = `/equipment-sub-type/edit/${alteredId}`;
      icon = 'book';
      break;
    case 'assettype':
      recordName = `Asset Type ${name}`;
      url = `/asset-type/edit/${alteredId}`;
      icon = 'container';
      break;
    case 'assetmake':
      recordName = `Asset Make ${name}`;
      url = `/asset-make/edit/${alteredId}`;
      icon = 'hdd';
      break;
    case 'assetmodel':
      recordName = `Asset Model ${name}`;
      url = `/asset-model/edit/${alteredId}`;
      icon = 'project';
      break;

  }
  // Resolve the record's location / sublocation (client) ids to their names
  // using the maps derived from authUser (always present in redux state).
  const locationName = (record && record.location && locationNameById && locationNameById[record.location]) || '';
  const clientName = (record && record.client && clientNameById && clientNameById[record.client]) || '';
  const locationLabel = [locationName, clientName].filter(Boolean).join(' / ');

  // Tint records whose location is SOLD.
  const isSold = typeof locationName === 'string' && locationName.trim().toUpperCase() === 'SOLD';
  const itemStyle = isSold
    ? { background: '#fff1f0', borderRadius: 3, padding: '2px 4px', margin: '-2px -4px' }
    : undefined;

  // Hide records the user has no access to (e.g. an asset whose location is not
  // in authUser.locations) instead of just hiding their "Click Here" link.
  return recordName && isShow && (
    <Option key={_id} text={name}>
      <div className="global-search-item" style={itemStyle}>
        {/*<i className={`icon ${icon} gx-fs-xs`} style={{float: 'left', marginRight: '5px'}}/>*/}
        <Icon type={icon} style={{ float: 'left', marginRight: '10px', marginTop: '5px' }} />
        <span className="global-search-item-desc">
          Found {/*{moduleType.toUpperCase()}*/}
        </span>
        <span style={{ marginLeft: '5px' }} className="global-search-item-count">{recordName}</span>
        <span style={{ float: 'right' }}><Link target={'_blank'} to={url}>Click Here</Link></span>
        {locationLabel && (
          <div className="global-search-item-location" style={{ clear: 'both', fontSize: 11, color: '#8c8c8c', marginTop: 2 }}>
            <Icon type="environment" style={{ marginRight: 4 }} />{locationLabel}
          </div>
        )}
      </div>
    </Option>
  );
}

const SearchBox = ({ styleName, placeholder, onChange, data, authUser, loading }) => {
  const [inputValue, setInputValue] = useState('');
  const [dataSource, setDataSource] = useState([]);
  const [locations, setLocations] = useState([]);
  const [subLocations, setSubLocations] = useState([]);
  const [locationNameById, setLocationNameById] = useState({});
  const [clientNameById, setClientNameById] = useState({});
  const debouncedSearchRef = useRef(null);
  const lastSearchedValueRef = useRef('');

  useEffect(() => {
    debouncedSearchRef.current = createDebounce((searchValue) => {
      if (lastSearchedValueRef.current === searchValue) {
        return;
      }
      lastSearchedValueRef.current = searchValue;
      onChange(searchValue);
    }, 400);

    return () => {
      if (debouncedSearchRef.current && debouncedSearchRef.current.cancel) {
        debouncedSearchRef.current.cancel();
      }
    };
  }, [onChange]);

  useEffect(() => {
    const normalizedInput = (inputValue || '').trim();
    if (!debouncedSearchRef.current) {
      return undefined;
    }
    if (normalizedInput.length < 3) {
      debouncedSearchRef.current.cancel();
      return undefined;
    }
    debouncedSearchRef.current(normalizedInput);
    return undefined;
  }, [inputValue]);

  useEffect(() => {
    if (data && data.length)
      setDataSource(data);
  }, [inputValue, data]);

  useEffect(() => {
    if (authUser && authUser.locations) {
      const loc = authUser && authUser.locations && authUser.locations.map(loc => loc._id);
      setLocations(loc);
      setLocationNameById(authUser.locations.reduce((map, l) => {
        if (l && l._id) map[l._id] = l.name;
        return map;
      }, {}));
    }
    if (authUser && authUser.clients) {
      const s_loc = authUser && authUser.clients && authUser.clients.map(sloc => sloc._id);
      setSubLocations(s_loc);
      setClientNameById(authUser.clients.reduce((map, c) => {
        if (c && c._id) map[c._id] = c.name;
        return map;
      }, {}));
    }
  }, [authUser]);

  const handleSearch = value => {
    setInputValue(value);
  };

  const onSelect = (val) => {
    // console.log(val)
  }
  {
    /*    <div className={`gx-search-bar ${styleName}`}>
          <div className="gx-form-group" style={{'border-radius': '25px', 'border': '1px solid #F5F5F5'}}>
            <Autocomplete className="ant-input" type="search" placeholder={placeholder} onChange={handleInputChange}/>
            <span className="gx-search-icon gx-pointer"><i className="icon icon-search"/></span>
          </div>
        </div>*/
  }
  return (
    <AutoComplete
      className="global-search"
      size="large"
      style={{ width: '100%' }}
      dataSource={dataSource
        .map((item) => renderOption(item, locations, subLocations, locationNameById, clientNameById))
        .filter(Boolean)}
      onSelect={onSelect}
      onSearch={handleSearch}
      placeholder={placeholder || "Search here ..."}
      optionLabelProp="text"
    >
      <Input
        suffix={
          <Button
            className="search-btn"
            style={{ marginRight: -12, marginTop: 15 }}
            size="large"
            type="primary"
          >
            <Icon type={loading ? 'loading' : 'search'} />
          </Button>
        }
      />
    </AutoComplete>
  )
};
export default SearchBox;

SearchBox.defaultProps = {
  styleName: "",
  value: "",
};
